import {styled} from '@mui/material/styles';

// TODO: Consolidate with dropdown
export const DropdownMenuWrapper = styled('div')(({theme}) => `
    display: inline-flex;
    align-items: flex-start;
    justify-content: start;

    background-color: ${theme.tokens.FuelColorWhite};
    border-radius: ${theme.tokens.FuelBorderRadiusMd};
    box-shadow: ${theme.tokens.FuelShadowXl};

    overflow: hidden;
    max-width: 100%;
`);
